// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/sbg-dynamic-share-price/sbg-dynamic-share-price.component.scss
// module id = 715
// module chunks = 0